import { AsyncPipe, KeyValuePipe } from '@angular/common';
import { ChangeDetectorRef, Component, inject, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbAlert, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { bootstrapFiletypeXlsx } from '@ng-icons/bootstrap-icons';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { Dictionary } from '@ngrx/entity';
import { SafePipe } from 'safe-pipe';
import { BackEndService } from 'src/app/services/backend.service';
import { DownloadComponentBase } from 'src/app/shared/components/download-component-base/download-component-base';
import { InputDialogComponent, InputDialogStepComponent } from 'src/app/shared/components/input-dialog/input-dialog.component';
import { Article } from 'src/app/state/article.model';

@Component({
  selector: 'export-to-xls',
  imports: [
    NgIcon,
    FormsModule,
    NgbProgressbarModule,
    InputDialogComponent,
    InputDialogStepComponent,
    SafePipe,
    AsyncPipe,
    KeyValuePipe,
    NgbAlert

  ],
  templateUrl: './export-to-xls.component.html',
  styleUrl: './export-to-xls.component.scss',
  providers: [provideIcons({ bootstrapFiletypeXlsx })]
})
export class ExportToXlsComponent extends DownloadComponentBase<Article> {

  public tableLookup: Dictionary<string> = {
    ai_situations: 'Situation',
    ai_bankruptcy_cases: 'Bankruptcy Case',
    ai_distressed: 'Distressed',
    ai_entities: 'Organization',
    ai_asset_sales: 'Asset Sale',
    ai_chapter_11_plans: 'Chapter 11 Plan',
    ai_instruments: 'Instrument',
    ai_keips: 'KEIP',
    ai_kerps: 'KERP',
  }
  public override contentSet = 'ai'

  historyID = input<number>(0, {alias: 'historyid'})
  parts = input<string>('', {alias: 'parts'})

  private changeDetector = inject(ChangeDetectorRef)

  exportToXLS(event: MouseEvent) {
    const parts = this.parts().split(',')
    if (this.historyID() && parts.length) {
      this.downloadParts = parts.reduce((acc: Dictionary<boolean | string>, item: any) => {
        acc[item] = false
        return acc
      }, {})
      this.downloadParts['table'] = true
      this.excelExportDialogComponent.showModal({ historyID: this.historyID(), parts })
      this.changeDetector.detectChanges()
    }
  }
}
